import { render, staticRenderFns } from "./RemarkInfo.vue?vue&type=template&id=7a0d8104&scoped=true&"
import script from "./RemarkInfo.vue?vue&type=script&lang=js&"
export * from "./RemarkInfo.vue?vue&type=script&lang=js&"
import style0 from "./RemarkInfo.vue?vue&type=style&index=0&id=7a0d8104&scoped=true&lang=scss&"
import style1 from "./RemarkInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0d8104",
  null
  
)

export default component.exports